import Vue from 'vue';
import Vuex from 'vuex';

import vuexI18n from 'vuex-i18n';
import Dutch from './lang/nl';

import AppNavigation from '@/views/stores/app-navigation/navigation';
import Modal from '@/shared/stores/modal';

import EmployersResource from '@/resources/stores/employers';
import EmployeesResource from '@/resources/stores/employees';
import ReportsOfSicknessResource from '@/resources/stores/reports-of-sickness';
import PoliciesResource from '@/resources/stores/policies';
import WorkStockResource from '@/resources/stores/work-stock';
import ProcessDatesResource from '@/resources/stores/process-dates';

import EmployeesNavigation from '@/views/stores/employees/navigation';
import ReportsOfSicknessNavigation from '@/views/stores/reports-of-sickness/navigation';
import ReportsOfSicknessToasters from '@/views/stores/reports-of-sickness/toasters';

import ReportsOfSicknessIndex from '@/views/stores/reports-of-sickness/index';
import EmployeesIndex from '@/views/stores/employees/index';
import WorkStockIndex from '@/views/stores/work-stock/index';

import NewReportOfSicknessNavigation from '@/views/stores/report-of-sickness-new/navigation';
import NewReportOfSicknessBase from '@/views/stores/report-of-sickness-new/base';

import ReportsOfSicknessImportNewBase from '@/views/stores/reports-of-sickness-import-new/base';
import ReportsOfSicknessImportNewNavigation from '@/views/stores/reports-of-sickness-import-new/navigation';

import EditReportOfSicknessNavigation from '@/views/stores/report-of-sickness-edit/navigation';
import EditReportOfSicknessBase from '@/views/stores/report-of-sickness-edit/base';

import NewPeriodBase from '@/views/stores/period-new/base';
import NewPeriodNavigation from '@/views/stores/period-new/navigation';
import EditPeriodBase from '@/views/stores/period-edit/base';
import EditPeriodNavigation from '@/views/stores/period-edit/navigation';

import NewRecoveryBase from '@/views/stores/recovery-new/base';
import NewRecoveryNavigation from '@/views/stores/recovery-new/navigation';
import EditRecoveryBase from '@/views/stores/recovery-edit/base';
import EditRecoveryNavigation from '@/views/stores/recovery-edit/navigation';

import EmployeeSummaryPersonalEdit from '@/views/stores/employee-summary-personal-edit/base';

import NewEmployeeBase from '@/views/stores/employee-new/base';
import NewEmployeeNavigation from '@/views/stores/employee-new/navigation';

import NewUwvDecisionBase from '@/views/stores/uwv-decision-new/base';
import NewUwvDecisionNavigation from '@/views/stores/uwv-decision-new/navigation';

import WorkStockNavigation from '@/views/stores/work-stock/navigation';

Vue.use(Vuex);

const langStore = new Vuex.Store();
Vue.use(vuexI18n.plugin, langStore);
Vue.i18n.add('nl', Dutch);
Vue.i18n.set('nl');

export default new Vuex.Store({
  modules: {
    AppNavigation,
    Modal,

    EmployersResource,

    EmployeesResource,
    EmployeesNavigation,
    EmployeesIndex,

    ReportsOfSicknessResource,
    ReportsOfSicknessNavigation,
    ReportsOfSicknessToasters,
    ReportsOfSicknessIndex,

    PoliciesResource,
    WorkStockResource,
    ProcessDatesResource,

    NewReportOfSicknessNavigation,
    NewReportOfSicknessBase,

    ReportsOfSicknessImportNewBase,
    ReportsOfSicknessImportNewNavigation,

    EditReportOfSicknessNavigation,
    EditReportOfSicknessBase,

    NewPeriodBase,
    NewPeriodNavigation,

    EditPeriodBase,
    EditPeriodNavigation,

    NewRecoveryBase,
    NewRecoveryNavigation,

    EditRecoveryBase,
    EditRecoveryNavigation,

    EmployeeSummaryPersonalEdit,

    NewEmployeeBase,
    NewEmployeeNavigation,

    NewUwvDecisionBase,
    NewUwvDecisionNavigation,

    WorkStockNavigation,
    WorkStockIndex
  }
});
